module.exports = __webpack_public_path__ + "img/SwiperNoData.75a8e7d6.png";